module.exports = __webpack_public_path__ + "undefined-lock.png?a9b27f91eceb63f1ca348d930e050abf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/attachment-format/undefined-lock.png
// module id = 43
// module chunks = 0